var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      ref: "dialog",
      attrs: {
        "append-to-body": "",
        "show-close": false,
        visible: _vm.dialogVisible,
        width: "35%",
      },
      on: {
        close: _vm.dialogClose,
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "main",
        },
        [
          _c(
            "div",
            { staticClass: "detail" },
            _vm._l(_vm.dataArr, function (items, indexs) {
              return _c(
                "div",
                { key: indexs, staticClass: "detail_box" },
                [
                  _c("div", { staticClass: "data" }, [
                    _c("p", { staticClass: "data_p2" }, [
                      _vm._v("D" + _vm._s(items.planDay)),
                    ]),
                    _c("p", { staticClass: "data_p1" }, [
                      _vm._v(
                        _vm._s(items.planDate) + " " + _vm._s(items.planCity)
                      ),
                    ]),
                  ]),
                  _vm._l(items.orderSurePlanResultList, function (item, index) {
                    return _c("div", { key: index }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(
                            item.budgetDetail.budget.resourceNameCn
                              ? item.budgetDetail.budget.resourceNameCn
                              : item.budgetDetail.budget.resourceNameEn
                          )
                        ),
                      ]),
                      _c("div", { staticClass: "detail_list" }, [
                        _c(
                          "div",
                          { staticClass: "detail_list_t" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    item.budgetDetail.stockDetail.budgetType +
                                    item.budgetDetail.stockDetail.mealText,
                                  placement: "top",
                                  effect: "light",
                                },
                              },
                              [
                                _c("p", { staticClass: "detail_list_t_p3" }, [
                                  _vm._v(
                                    _vm._s(
                                      item.budgetDetail.stockDetail.budgetType
                                    ) +
                                      "+" +
                                      _vm._s(
                                        item.budgetDetail.stockDetail.mealText
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]
                            ),
                            _c("p", { staticClass: "detail_list_t_p1" }, [
                              _vm._v(_vm._s(item.budgetDetail.productName)),
                            ]),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    item.budgetDetail.stockDetail.productDesc,
                                  placement: "top",
                                  effect: "light",
                                },
                              },
                              [
                                _c("p", { staticClass: "detail_list_t_p3" }, [
                                  _vm._v(
                                    _vm._s(
                                      item.budgetDetail.stockDetail.productDesc
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c("p", [
                              _vm._v(
                                _vm._s(item.budgetDetail.ratio) +
                                  _vm._s(item.budgetDetail.currency) +
                                  "/" +
                                  _vm._s(item.budgetDetail.timeUnit) +
                                  "/" +
                                  _vm._s(item.budgetDetail.quantityUnit)
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                _vm._s(item.budgetDetail.stockNumber) +
                                  _vm._s(item.budgetDetail.quantityUnit)
                              ),
                            ]),
                            _c("p", { staticClass: "detail_list_t_p2" }, [
                              _vm._v(
                                _vm._s(
                                  item.budgetDetail.stockNumber *
                                    Number(item.budgetDetail.ratio)
                                ) + _vm._s(item.budgetDetail.currency)
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "detail_list_b" }, [
                          _c(
                            "div",
                            { staticClass: "detail_list_b_l" },
                            [
                              _c("p", { staticClass: "detail_list_b_l_p1" }, [
                                _vm._v("行程"),
                              ]),
                              _vm.maintenanceData !== "{}"
                                ? _c(
                                    "el-popover",
                                    {
                                      ref: "popoverRef",
                                      refInFor: true,
                                      attrs: {
                                        placement: "right-start",
                                        width: "425",
                                        trigger: "manual",
                                      },
                                      model: {
                                        value: item.visible,
                                        callback: function ($$v) {
                                          _vm.$set(item, "visible", $$v)
                                        },
                                        expression: "item.visible",
                                      },
                                    },
                                    [
                                      !_vm.detection
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "detail_list_b_l_span1",
                                              attrs: { slot: "reference" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.maintenance(item)
                                                },
                                              },
                                              slot: "reference",
                                            },
                                            [_vm._v("维护")]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "edit" },
                                        [
                                          _c("svg-icon", {
                                            staticStyle: {
                                              "margin-right": "0.05rem",
                                              cursor: "pointer",
                                              height: "0.17rem",
                                              position: "absolute",
                                              right: "0.2rem",
                                              top: "0",
                                            },
                                            attrs: { iconClass: "file" },
                                            on: { click: _vm.save },
                                          }),
                                          _c("svg-icon", {
                                            staticStyle: {
                                              cursor: "pointer",
                                              height: "0.25rem",
                                              position: "absolute",
                                              right: "0",
                                              top: "-0.05rem",
                                            },
                                            attrs: { iconClass: "close" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.closePopover(item)
                                              },
                                            },
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "edit_prompt" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "edit_prompt_p1",
                                                },
                                                [_vm._v("详细用车行程维护")]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "edit_prompt_p2",
                                                },
                                                [
                                                  _vm._v(
                                                    "鼠标点击单独产品上即可维护接送及途径地点"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm.maintenanceData !== "{}"
                                            ? _c(
                                                "div",
                                                { staticClass: "edit_detail" },
                                                [
                                                  _vm._l(
                                                    _vm.maintenanceData
                                                      .meetList,
                                                    function (n, m) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: "meetList" + m,
                                                          staticClass:
                                                            "detail_list_b_block",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "detail_list_b_r_yuan",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.editPlan(
                                                                      n
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v(" 接 ")]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "detail_list_b_r_p1",
                                                              staticStyle: {
                                                                cursor:
                                                                  "pointer",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.editPlan(
                                                                      n
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  n.resourceNameCn
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  _vm._l(
                                                    _vm.maintenanceData.tuList,
                                                    function (n, m) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: "tuList" + m,
                                                          staticClass:
                                                            "detail_list_b_block",
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "detail_list_b_r_p1",
                                                              staticStyle: {
                                                                cursor:
                                                                  "pointer",
                                                                display: "flex",
                                                                "align-items":
                                                                  "center",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.editPlan(
                                                                      n
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("svg-icon", {
                                                                staticStyle: {
                                                                  "margin-right":
                                                                    "0.05rem",
                                                                },
                                                                attrs: {
                                                                  iconClass:
                                                                    "car",
                                                                  systemColor:
                                                                    "#7D7D7D",
                                                                },
                                                              }),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    n.resourceNameCn
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  _vm._l(
                                                    _vm.maintenanceData
                                                      .giveList,
                                                    function (n, m) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: "giveList" + m,
                                                          staticClass:
                                                            "detail_list_b_block",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "detail_list_b_r_yuan",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.editPlan(
                                                                      n
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v(" 送 ")]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "detail_list_b_r_p1",
                                                              staticStyle: {
                                                                cursor:
                                                                  "pointer",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.editPlan(
                                                                      n
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    n.resourceNameCn
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            { staticClass: "edit_other" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "edit_other_p1",
                                                },
                                                [_vm._v("添加行程轴外的")]
                                              ),
                                              _c(
                                                "el-radio-group",
                                                {
                                                  model: {
                                                    value: _vm.radio,
                                                    callback: function ($$v) {
                                                      _vm.radio = $$v
                                                    },
                                                    expression: "radio",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-radio",
                                                    { attrs: { label: 0 } },
                                                    [_vm._v("酒店")]
                                                  ),
                                                  _c(
                                                    "el-radio",
                                                    { attrs: { label: 2 } },
                                                    [_vm._v("景点")]
                                                  ),
                                                  _c(
                                                    "el-radio",
                                                    { attrs: { label: 15 } },
                                                    [_vm._v("航班")]
                                                  ),
                                                  _c(
                                                    "el-radio",
                                                    { attrs: { label: 4 } },
                                                    [_vm._v("餐厅")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._l(
                                            _vm.initOtherData[_vm.radio],
                                            function (n, m) {
                                              return _c(
                                                "div",
                                                {
                                                  key: m,
                                                  staticClass:
                                                    "edit_other_detail",
                                                },
                                                [
                                                  m ===
                                                  _vm.initOtherData[_vm.radio]
                                                    .length -
                                                    1
                                                    ? _c("i", {
                                                        staticClass:
                                                          "el-icon-circle-plus-outline edit_other_detail_del",
                                                        on: {
                                                          click: _vm.addOther,
                                                        },
                                                      })
                                                    : _c("i", {
                                                        staticClass:
                                                          "el-icon-remove-outline edit_other_detail_del",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.delOther(
                                                              m
                                                            )
                                                          },
                                                        },
                                                      }),
                                                  _vm.radio == 15
                                                    ? _c("div", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "edit_other_detail_t",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "edit_other_detail_t_yuan_box",
                                                              },
                                                              _vm._l(
                                                                _vm.btnType,
                                                                function (a) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: a.code,
                                                                      staticClass:
                                                                        "edit_other_detail_t_yuan",
                                                                      class:
                                                                        n.mode ==
                                                                        a.code
                                                                          ? "active2"
                                                                          : "active1",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.handlerSwClick(
                                                                              n,
                                                                              a.code
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            a.name
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                            _c("el-input", {
                                                              attrs: {
                                                                size: "small",
                                                                placeholder:
                                                                  "请输入航班号、起飞机场、降落机场",
                                                              },
                                                              model: {
                                                                value:
                                                                  n.resourceNameCn,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      n,
                                                                      "resourceNameCn",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "n.resourceNameCn",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "edit_other_detail_b",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "edit_other_detail_b_l",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "edit_other_detail_b_l_div",
                                                                  },
                                                                  [
                                                                    _c("p", [
                                                                      _vm._v(
                                                                        "起飞时间"
                                                                      ),
                                                                    ]),
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-size":
                                                                              "0.12rem",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "(本地时间)"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "el-date-picker",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "1.8rem",
                                                                      },
                                                                    attrs: {
                                                                      "value-format":
                                                                        "timestamp",
                                                                      size: "small",
                                                                      type: "datetime",
                                                                      placeholder:
                                                                        "选择时间",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        n.startTime,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            n,
                                                                            "startTime",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "n.startTime",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "edit_other_detail_b_l",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "edit_other_detail_b_l_div",
                                                                  },
                                                                  [
                                                                    _c("p", [
                                                                      _vm._v(
                                                                        "降落时间"
                                                                      ),
                                                                    ]),
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-size":
                                                                              "0.12rem",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "(本地时间)"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "el-date-picker",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "1.8rem",
                                                                      },
                                                                    attrs: {
                                                                      "value-format":
                                                                        "timestamp",
                                                                      size: "small",
                                                                      type: "datetime",
                                                                      placeholder:
                                                                        "选择时间",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        n.endTime,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            n,
                                                                            "endTime",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "n.endTime",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _c("div", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "edit_other_detail_t",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "edit_other_detail_t_yuan_box",
                                                              },
                                                              _vm._l(
                                                                _vm.btnType,
                                                                function (a) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: a.code,
                                                                      staticClass:
                                                                        "edit_other_detail_t_yuan",
                                                                      class:
                                                                        n.mode ==
                                                                        a.code
                                                                          ? "active2"
                                                                          : "active1",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.handlerSwClick(
                                                                              n,
                                                                              a.code
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            a.name
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                            _c("el-input", {
                                                              attrs: {
                                                                size: "small",
                                                                placeholder:
                                                                  "请输入" +
                                                                  _vm
                                                                    .selectType[
                                                                    _vm.radio
                                                                  ],
                                                              },
                                                              model: {
                                                                value:
                                                                  n.resourceNameCn,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      n,
                                                                      "resourceNameCn",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "n.resourceNameCn",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "edit_other_detail_b",
                                                          },
                                                          [
                                                            _c(
                                                              "el-time-picker",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    n.startTime,
                                                                  "value-format":
                                                                    "HH:mm",
                                                                  format:
                                                                    "HH:mm",
                                                                  placeholder:
                                                                    "抵达时间",
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.selectTime(
                                                                        $event,
                                                                        items.planDate,
                                                                        n
                                                                      )
                                                                    },
                                                                },
                                                              }
                                                            ),
                                                            _c("el-input", {
                                                              attrs: {
                                                                size: "small",
                                                                placeholder:
                                                                  "如有您需要备注的请在此处输入",
                                                              },
                                                              model: {
                                                                value: n.remark,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      n,
                                                                      "remark",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "n.remark",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "detail_list_b_r" },
                            [
                              _vm._l(item.meetList, function (n, m) {
                                return _c(
                                  "div",
                                  {
                                    key: "meetList" + m,
                                    staticClass: "detail_list_b_block",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "detail_list_b_r_yuan" },
                                      [_vm._v(" 接 ")]
                                    ),
                                    _c(
                                      "p",
                                      { staticClass: "detail_list_b_r_p1" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            n.resourceNameCn
                                              ? n.resourceNameCn
                                              : n.resourceNameEn
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              _vm._l(item.tuList, function (n, m) {
                                return _c(
                                  "div",
                                  {
                                    key: "tuList" + m,
                                    staticClass: "detail_list_b_block",
                                  },
                                  [
                                    _c("svg-icon", {
                                      staticStyle: {
                                        "margin-right": "0.05rem",
                                      },
                                      attrs: {
                                        iconClass: "car",
                                        systemColor: "#7D7D7D",
                                      },
                                    }),
                                    _c(
                                      "p",
                                      { staticClass: "detail_list_b_r_p1" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            n.resourceNameCn
                                              ? n.resourceNameCn
                                              : n.resourceNameEn
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              _vm._l(item.giveList, function (n, m) {
                                return _c(
                                  "div",
                                  {
                                    key: "giveList" + m,
                                    staticClass: "detail_list_b_block",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "detail_list_b_r_yuan" },
                                      [_vm._v(" 送 ")]
                                    ),
                                    _c(
                                      "p",
                                      { staticClass: "detail_list_b_r_p1" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            n.resourceNameCn
                                              ? n.resourceNameCn
                                              : n.resourceNameEn
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ])
                  }),
                ],
                2
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "main_btn_box" },
        [
          _c(
            "el-button",
            {
              staticClass: "main_btn",
              staticStyle: { "margin-right": "0.3rem" },
              attrs: {
                type: "primary",
                size: "mini",
                disabled: _vm.areYouSure,
              },
              on: { click: _vm.confirmItinerary },
            },
            [
              _vm._v(
                _vm._s(_vm.detection ? "确认行程" : "确认行程并下单") + " "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }